(function () {
  initializeUtilsFunctions();
  function callApiCreateLead(request, campId) {
    const uri = '/api/lead/createLead';
    callApi({
      uri: window.location.origin + sanitizeUri(uri),
      method: 'POST',
      data: request,
    })
      .then((response) => {
        if (
          drupalSettings.facebookApiConverter.facebookTrackingEnabled &&
          drupalSettings.facebookApiConverter.facebookUrlIp
        ) {
          if (
            typeof fbq !== 'undefined' &&
            drupalSettings.facebookApiConverter.facebook_pixel_1 &&
            drupalSettings.facebookApiConverter.facebook_pixel_2
          ) {
            if (campId && campId.indexOf('newaccount') >= 0) {
              //second pixel
              fbq(
                'trackSingle',
                drupalSettings.facebookApiConverter.facebook_pixel_2,
                'Lead',
                {},
                { eventID: 'Lead.' + response.leadId },
              );
            } else {
              //first pixel
              fbq(
                'trackSingle',
                drupalSettings.facebookApiConverter.facebook_pixel_1,
                'Lead',
                {},
                { eventID: 'Lead.' + response.leadId },
              );
            }
          }
        }

        gtag('event', 'conversion', {
          send_to: 'AW-676572607/EFtHCIW8ysQBEL_bzsIC',
        });
        const widget = document.querySelector('#widget-article');
        widget.querySelector('.loader').classList.remove('active');
        if (response) {
          widget.querySelector('.form-to-complete').classList.add('hidden');
          widget.querySelector('.form-completed').classList.remove('hidden');
          widget
            .querySelector('.text-form-to-complete')
            .classList.add('hidden');
          widget
            .querySelector('.text-form-completed')
            .classList.remove('hidden');
        } else {
          widget.querySelector('#tel').removeAttribute('disabled');
          widget
            .querySelector('.send-partial-lead')
            .removeAttribute('disabled');
        }
      })
      .catch((e) => {
        console.error(e.message);
      });
  }

  function createPartialLead() {
    const widget = document.querySelector('#widget-article');
    if (widget) {
      const widgetOfferItem = widget.querySelector('.offer-item-image');
      const urlParams = new URLSearchParams(window.location.search);
      if (
        widgetOfferItem &&
        widget.querySelector('#tel').classList.contains('valid')
      ) {
        let master_key_full = null;
        let cmpid = urlParams.get('cmpid');
        let widgetMK = drupalSettings.widget.field_widget_masterkey;
        if (widgetMK) {
          widgetMK = widgetMK.replace(
            '[campaign_id]',
            widgetOfferItem.getAttribute('data-mk-campaign-id')
              ? widgetOfferItem.getAttribute('data-mk-campaign-id')
              : 'NA',
          );
          widgetMK = widgetMK.replace(
            '[offer_id]',
            widgetOfferItem.getAttribute('data-mk-offer-id')
              ? widgetOfferItem.getAttribute('data-mk-offer-id')
              : 'NA',
          );
          widgetMK = widgetMK.replace(
            '[campaign_description]',
            widgetOfferItem.getAttribute('data-mk-campaign-description')
              ? widgetOfferItem.getAttribute('data-mk-campaign-description')
              : 'NA',
          );
          widgetMK = widgetMK.replace(
            '[offer_description]',
            widgetOfferItem.getAttribute('data-mk-offer-description')
              ? widgetOfferItem.getAttribute('data-mk-offer-description')
              : 'NA',
          );
          if (window.innerWidth > 500) {
            widgetMK = widgetMK.replace('[device]', 'desktop');
          } else {
            widgetMK = widgetMK.replace('[device]', 'mobile');
          }
          const url = getParameterByName('referer');
          if (url) {
            const queryArr = url.split('?');
            widgetMK = widgetMK.replace('[url]', queryArr[0]);
            if (queryArr.length > 1) {
              widgetMK = widgetMK.replace('[query]', queryArr[1]);
            } else {
              widgetMK = widgetMK.replace('[query]', 'NA');
            }
          } else {
            widgetMK = widgetMK.replace('[url]', 'NA');
            widgetMK = widgetMK.replace('[query]', 'NA');
          }

          const mksplit = widgetMK.split('|');
          if (mksplit.length === 19) {
            master_key_full = {
              campaign_ID: mksplit[0],
              offer_ID: mksplit[1],
              campaign_descr: mksplit[2],
              offer_descry: mksplit[3],
              cta: mksplit[4],
              market: mksplit[5],
              language: mksplit[6],
              level0: mksplit[7],
              level1: mksplit[8],
              level2: mksplit[9],
              source: mksplit[10],
              device: mksplit[11],
              business_area: mksplit[12],
              publisher: mksplit[13],
              media_crm_campaign_id: mksplit[14],
              media_crm_campaign: mksplit[15],
              referrel: mksplit[16],
              url: mksplit[17],
              full_query: mksplit[18],
            };
            const md = new MobileDetect(window.navigator.userAgent);
            let device = 'desktop';
            if (md.phone()) {
              device = 'mobile';
            } else if (md.tablet()) {
              device = 'tablet';
            }
            master_key_full.device = device;

            if (getCookie('naturalSearch')) {
              master_key_full.source = 'natural-search';
            }
            if (cmpid) {
              master_key_full.full_query = 'cmpid=' + cmpid;
              cmpid = cmpid.split('_');
              master_key_full.source = cmpid[0];
              master_key_full.publisher = cmpid[8];
              master_key_full.media_crm_campaign_id = cmpid[6];
              master_key_full.media_crm_campaign = cmpid[9];
            }
          }
        }

        // nuova logica masterkey
        let request = {
          phoneNumber: widget.querySelector('#tel').value
            ? widget.querySelector('#tel').value
            : null,
          brandId: widgetOfferItem.getAttribute('data-brand-id')
            ? widgetOfferItem.getAttribute('data-brand-id')
            : null,
          modelId: widgetOfferItem.getAttribute('data-model-id')
            ? widgetOfferItem.getAttribute('data-model-id')
            : null,
          promoId: widgetOfferItem.getAttribute('data-promo-id')
            ? widgetOfferItem.getAttribute('data-promo-id')
            : null,
          variationId: widgetOfferItem.getAttribute('data-variation-id')
            ? widgetOfferItem.getAttribute('data-variation-id')
            : null,
          variationName: widgetOfferItem.getAttribute('data-variation-name')
            ? widgetOfferItem.getAttribute('data-variation-name')
            : null,
          modelName: widgetOfferItem.getAttribute('data-model-name')
            ? widgetOfferItem.getAttribute('data-model-name')
            : null,
          brandName: widgetOfferItem.getAttribute('data-brand-name')
            ? widgetOfferItem.getAttribute('data-brand-name')
            : null,
          promoName: widgetOfferItem.getAttribute('data-promo-name')
            ? widgetOfferItem.getAttribute('data-promo-name')
            : null,
          leadPurpose: widgetOfferItem.getAttribute('data-offer-purpose')
            ? widgetOfferItem.getAttribute('data-offer-purpose')
            : null,
          externalChannel: widget.getAttribute('data-partner')
            ? widget.getAttribute('data-partner')
            : null,
          rentalOperator: widgetOfferItem.getAttribute('data-rental-operator')
            ? widgetOfferItem.getAttribute('data-rental-operator')
            : null,
          isExternal: true,
          masterKey: cmpid
            ? Object.values(master_key_full).join('|')
            : widgetMK,
          motornetId: widgetOfferItem.getAttribute('data-motornet-id')
            ? widgetOfferItem.getAttribute('data-motornet-id')
            : null,
        };

        let campId = localStorage.getItem('cmpid')
          ? localStorage.getItem('cmpid')
          : localStorage.getItem('intcmpid');
        let pixelId = '';
        if (campId && campId.indexOf('newaccount') >= 0) {
          //second pixel
          pixelId = drupalSettings.facebookApiConverter.facebook_pixel_2;
        } else {
          //first pixel
          pixelId = drupalSettings.facebookApiConverter.facebook_pixel_1;
        }
        widget.querySelector('#tel').setAttribute('disabled', true);
        widget
          .querySelector('.send-partial-lead')
          .setAttribute('disabled', true);
        const idEvent = Date.now();
        const idEventSha = SHA256('' + idEvent);
        if (
          !getCookie('publicIp') ||
          getCookie('publicIp').split('=').length <= 1
        ) {
          jQuery.get(
            drupalSettings.facebookApiConverter &&
              drupalSettings.facebookApiConverter.facebookUrlIp
              ? drupalSettings.facebookApiConverter.facebookUrlIp
              : 'https://api.ipify.org',
            function (data) {
              createCookieWithValue('publicIp', data, 60);
              request = {
                ...request,
                facebookEnabled:
                  drupalSettings.facebookApiConverter &&
                  drupalSettings.facebookApiConverter.facebookTrackingEnabled,
                facebookPayload:
                  drupalSettings.facebookApiConverter &&
                  drupalSettings.facebookApiConverter.facebookTrackingEnabled
                    ? {
                        referrer: window.location.href,
                        eventName: 'Lead',
                        userAgent: navigator.userAgent,
                        pixelId,
                        ip: data,
                        externalId: idEventSha,
                        fbp:
                          getCookie('_fbp') &&
                          getCookie('_fbp').split('=').length > 1
                            ? getCookie('_fbp').split('=')[1]
                            : '',
                        fbc:
                          getCookie('_fbc') &&
                          getCookie('_fbc').split('=').length > 1
                            ? getCookie('_fbc').split('=')[1]
                            : '',
                      }
                    : {},
              };
              callApiCreateLead(request, campId);
            },
          );
        } else {
          request = {
            ...request,
            facebookEnabled:
              drupalSettings.facebookApiConverter &&
              drupalSettings.facebookApiConverter.facebookTrackingEnabled,
            facebookPayload:
              drupalSettings.facebookApiConverter &&
              drupalSettings.facebookApiConverter.facebookTrackingEnabled &&
              drupalSettings.facebookApiConverter.facebook_pixel_1 &&
              drupalSettings.facebookApiConverter.facebook_pixel_2
                ? {
                    referrer: window.location.href,
                    eventName: 'Lead',
                    userAgent: navigator.userAgent,
                    pixelId,
                    ip: getCookie('publicIp').split('=')[1],
                    externalId: idEventSha,
                    fbp:
                      getCookie('_fbp') &&
                      getCookie('_fbp').split('=').length > 1
                        ? getCookie('_fbp').split('=')[1]
                        : '',
                    fbc:
                      getCookie('_fbc') &&
                      getCookie('_fbc').split('=').length > 1
                        ? getCookie('_fbc').split('=')[1]
                        : '',
                  }
                : {},
          };
          callApiCreateLead(request, campId);
          widget.querySelector('.loader').classList.add('active');
        }
      }
    }
  }

  function getOfferFromProspecting() {
    widget.querySelector('#tel').setAttribute('disabled', true);
    widget.querySelector('.send-partial-lead').setAttribute('disabled', true);
    widget.querySelector('.loader').classList.add('active');
    const segment = getParameterByName('segment');
    const brand = getParameterByName('brand');
    const model = getParameterByName('model');
    const rentalOperator = getParameterByName('rentalOperator');

    const request = {
      brand: brand ? brand : undefined,
      segment: segment ? segment : undefined,
      model: model ? model : undefined,
      offer_purpose: rentalOperator ? 'rental' : 'selling',
      rental_operator: rentalOperator ? rentalOperator : null,
    };
    const uri = '/api/relatedOffer';
    callApi({
      uri: window.location.origin + sanitizeUri(uri),
      method: 'POST',
      data: request,
    })
      .then((resp) => {
        const widget = document.querySelector('#widget-article');
        widget.querySelector('.loader').classList.remove('active');
        widget.querySelector('.widget-form-carousel').style.visibility =
          'visible';
        if (resp) {
          widget.querySelector('#tel').removeAttribute('disabled');
          widget
            .querySelector('.send-partial-lead')
            .removeAttribute('disabled');
          const widgetImage = widget.querySelector('.offer-item-image');
          if (widgetImage) {
            if (resp.brandId) {
              widgetImage.setAttribute('data-brand-id', resp.brandId);
              widgetImage.setAttribute('data-brand-name', resp.brandName);
              widgetImage.setAttribute('data-model-id', resp.modelId);
              widgetImage.setAttribute('data-model-name', resp.modelName);
              widgetImage.setAttribute('data-variation-id', resp.variationId);
              widgetImage.setAttribute(
                'data-variation-name',
                resp.variationName,
              );
              widgetImage.setAttribute('data-promo-id', resp.offerId);
              widgetImage.setAttribute('data-promo-name', resp.offerName);
              widgetImage.setAttribute(
                'data-motornet-id',
                resp.modelMotornetId,
              );
              widgetImage.setAttribute('data-offer-purpose', resp.offerPurpose);
              widgetImage.setAttribute(
                'data-rental-operator',
                resp.rentalOperator,
              );
              widgetImage
                .querySelector('img')
                .setAttribute('src', resp.imageUrl);
              const widgetText = widget.querySelector('.offer-item-text');
              if (widgetText) {
                widgetText.querySelector('.text-form-to-complete').innerHTML =
                  drupalSettings.widget.field_widget_text_to_complete +
                  ' ' +
                  (resp.text
                    ? resp.text
                    : resp.brandName + ' ' + resp.modelName);
                widgetText.querySelector('.text-form-completed').innerHTML =
                  drupalSettings.widget.field_widget_text_completed +
                  ' ' +
                  (resp.text
                    ? resp.text
                    : resp.brandName + ' ' + resp.modelName);
                let privacyText = drupalSettings.widget.field_widget_privacy;
                if (resp.privacyText) {
                  privacyText = privacyText.replace(
                    'INFORMATIVA_BRAND',
                    "<a href='" +
                      resp.privacyText.widget_privacy_link.uri +
                      "' target='_blank'>" +
                      resp.privacyText.widget_privacy_link.title +
                      '</a>',
                  );
                }
                if (resp.mandatoryPrefix && resp.mandatoryPrefix === '1') {
                  showPrefixPhone = true;
                }
                widget.querySelector('.widget-privacy-part').innerHTML =
                  privacyText;
                widget.querySelector('.widget-privacy-part').style.visibility =
                  'visible';
                widgetText
                  .querySelector('.text-form-completed')
                  .classList.add('hidden');
                widget
                  .querySelector('#tel + label')
                  .addEventListener('click', () =>
                    widget.querySelector('#tel').focus(),
                  );
              }
            }
          }
        } else if (+this.status >= 400) {
          widget.querySelector('#tel').removeAttribute('disabled');
          widget
            .querySelector('.send-partial-lead')
            .removeAttribute('disabled');
        }
      })
      .catch((e) => {
        console.error(e.message);
      });
  }

  function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  const widget = document.querySelector('#widget-article');

  function validateInput(el) {
    let telRegex = /^[0-9+]{9,13}$/gi;
    if (showPrefixPhone) {
      if (el.value.length < 3) {
        el.value = '+39';
      }
      telRegex = /^(\+39)[0-9]{9,13}$/gi;
    }
    if (!telRegex.test(el.value)) {
      if (!el.classList.contains('invalid')) {
        el.classList.add('invalid');
      }
      if (el.classList.contains('valid')) {
        el.classList.remove('valid');
      }
    } else {
      if (el.classList.contains('invalid')) {
        el.classList.remove('invalid');
      }
      if (!el.classList.contains('valid')) {
        el.classList.add('valid');
      }
    }
  }
  let showPrefixPhone = false;
  if (widget) {
    widget
      .querySelector('.send-partial-lead')
      .addEventListener('click', createPartialLead);
    widget.querySelector('#tel').addEventListener('keyup', (e) => {
      const el = e.currentTarget;
      validateInput(el);
    });
    widget.querySelector('#tel').addEventListener('click', (e) => {
      const el = e.currentTarget;
      validateInput(el);
    });
    getOfferFromProspecting();
    window.addEventListener('load', function () {
      if (document.querySelector('#_cpmt-iframe')) {
        document.querySelector('#_cpmt-iframe').remove();
      }
    });
  }
})();
